export default __webpack_public_path__ + "static/media/part-3.06821a15.jpg";